import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IDropdown, IPlanStatusDropdown } from "../../models/BaseModel";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDate } from "../../shared/JVDate";

export interface IFilter {
    contact?: IDropdown;
    contact_ID?: number;
    status_ID?: number;
    source_ID?: number;
    countryId?: number;
    stateId?: number;
    cityId?: number;
    assigned_To?: number;
    show_Customerwise?: boolean;
    fromDate?: Date;
    toDate?: Date;
    dateType?: string;
}

const schema = yup.object({});

interface Iprops {
    filter: IFilter,
    loading: boolean,
    header: any,
    setFilter: (filter: IFilter) => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Filter = (props: Iprops) => {
    const [users, setUsers] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    const [contacts, setContacts] = useState<IDropdown[]>();
    const [devices, setDevices] = useState<IDropdown[]>();
    const [plans, setPlans] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();
    const [plansStatus, setPlansStatus] = useState<IPlanStatusDropdown[]>();
    const [teamLead, setTeamLead] = useState<IDropdown[]>();

    const dateTypes = [
        { id: "created", name: "Created Date" },
        { id: "expired", name: "Expired Date" }
    ];

    const { control, handleSubmit, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: {
            ...props.filter,
            dateType: "created"
        },
        shouldFocusError: false
    });

    const countryId = watch("countryId");
    const stateId = watch("stateId");

    useEffect(() => {
        loadUsers();
        loadStatus();
        loadDevices();
        loadPlans();
        loadPlanStatus();
        loadTeamLead();

    }, []);

    useEffect(() => {
        if (countryId) {
            setValue("stateId", undefined);
            setValue("cityId", undefined);
            setStates([]);
            setCities([]);
            loadStates(countryId);
        }
    }, [countryId]);

    useEffect(() => {
        if (stateId) {
            setValue("cityId", undefined);
            setCities([]);
            loadCities(stateId);
        }
    }, [stateId]);

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            const statusList = await response.json();
            setStatus([{ id: undefined, name: "--Select Status--" }, ...statusList]);
        }
    }

    const loadDevices = async () => {
        const response = await Fetch("device/dropdown", "GET", null, null, null);
        if (response) {
            const sourceList = await response.json();
            setDevices([{ id: undefined, name: "--Select Devices--" }, ...sourceList]);
        }
    }

    const loadPlans = async () => {
        const response = await Fetch("subscription_Plan/dropdown", "GET", null, null, null);
        if (response) {
            const sourceList = await response.json();
            setPlans([{ id: undefined, name: "--Select Devices--" }, ...sourceList]);
        }
    }

    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setUsers([{ id: undefined, name: "--Select--" }, ...userList]);
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            const stateList = await response.json();
            setStates([{ id: undefined, name: "--Select State--" }, ...stateList]);
        }
    }

    const loadCities = async (stateId: number) => {
        const response = await Fetch(`city/dropdown/${stateId}`, "GET", null, null, null);
        if (response) {
            const cityList = await response.json();
            setCities([{ id: undefined, name: "--Select City--" }, ...cityList]);
        }
    }

    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact_Person/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }

    const loadPlanStatus = async () => {
        const response = await Fetch("PlanStatus/dropdown", "GET", null, null, null);
        if (response) {
            const planlist = await response.json();
            setPlansStatus([{ id: undefined, name: "--Select --" }, ...planlist]);
        }
    }
    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    const loadTeamLead = async () => {
        const response = await Fetch("dropdown/getTeamLead", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setTeamLead([{ id: undefined, name: "--Select--" }, ...userList]);
        }
    }

    const searchToDB = async (body: IFilter) => { props.setFilter(body); }

    function onSubmit(data: IFilter) {
        if (data.contact) {
            data.contact_ID = data.contact.id;
        }
        searchToDB(data);
    }

    const Clear = () => {
        reset({});
        setStates([]);
        setCities([]);
    }

    return (
        <Accordion>
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdown column={4} label="Filter By" control={control} options={dateTypes} optionLabel="name" optionValue="id" name="dateType" placeholder="Select Date Type" />
                    <JVDate column={4} label="From Date" control={control} name="fromDate" />
                    <JVDate column={4} label="To Date" control={control} name="toDate" />
                    <JVDropdownInput column={4} completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" options={contacts} optionLabel="contact_Person_Name" placeholder="Search Contact" />
                    <JVDropdown column={4} label="Device" control={control} options={devices} optionLabel="device_Name" optionValue="id" name="device_ID" placeholder="Select Device" />
                    <JVDropdown column={4} label="Plan" control={control} options={plans} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Plan" />
                    <JVDropdown column={4} label="Status" control={control} options={plansStatus} optionLabel="status_Title" optionValue="id" name="planStatus_id" placeholder="Select Plan Status" />
                    {props.hasPermission("Lead", "teamLeadFilter") && <JVDropdown column={4} label="Team" control={control} options={teamLead} optionLabel="name" optionValue="id" name="team_Lead" placeholder="Select" />}
                    <JVDropdown column={4} label="Sales Manager" control={control} options={users} optionLabel="name" optionValue="id" name="assigned_To" placeholder="Select" />

                    <JVCheckbox column={4} label="Show Customer Wise" control={control} name="show_Customerwise" />
                    {/* <JVDropdown column={4} label="Country" control={control} options={countries} optionLabel="name" optionValue="id" name="countryId" placeholder="Select Country" />
                    <JVDropdown column={4} label="State" control={control} options={states} optionLabel="name" optionValue="id" name="stateId" placeholder="Select State" />
                    <JVDropdown column={4} label="City" control={control} options={cities} optionLabel="name" optionValue="id" name="cityId" placeholder="Select City" /> */}
                    <div className="col-12 md:col-3 gap-4 flex align-items-center justify-content-center mt-3">
                        <Button style={{ width: '100px', height: '34px' }} loading={props.loading} label="SEARCH" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px', height: '34px' }} label="CLEAR" onClick={Clear} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </AccordionTab>
        </Accordion>
    );
}
